// API base URL - in production this points to the separate API domain
const apiUrl = import.meta.env.VITE_API_URL

// Validate API URL is set in production
if (import.meta.env.PROD && !apiUrl) {
	console.error(
		'[Config] VITE_API_URL is not set. API requests will fail. ' +
			'Please set VITE_API_URL environment variable.',
	)
}

export const API_URL = apiUrl ?? ''

// API Token for local network authentication
export const API_TOKEN = import.meta.env.VITE_API_TOKEN as string | undefined

// Local-dev staff-login bypass (VITE_DEV_FAKE_STAFF=true in the root .env).
// The import.meta.env.DEV guard is statically false in production builds, so
// the bypass (and every branch behind it) is dead-code-eliminated there —
// setting the variable in a prod build has no effect. Server-side access
// still comes from VITE_API_TOKEN (staffProcedure), not from this flag.
export const DEV_FAKE_STAFF =
	import.meta.env.DEV && import.meta.env.VITE_DEV_FAKE_STAFF === 'true'

// Calendar limits
export const MAX_PP_PER_DAY = 8

// AppointmentDialog UI variant.
// Set VITE_APPOINTMENT_DIALOG_VARIANT at build time (per customer) to swap the dialog's UI.
// Must match a key registered in components/dialogs/AppointmentDialog/variants/registry.ts.
// Falls back to 'default' if unset or unknown.
export const APPOINTMENT_DIALOG_VARIANT = import.meta.env.VITE_APPOINTMENT_DIALOG_VARIANT as string | undefined
